const listaMenus = [
  {
    id: 'Dashboard',
    icon: 'home',
    title: 'MENU.HOME',
    to: '/dashboard/classic-dashboard',
  },
  {
    id: 'Academico',
    icon: 'book-open',
    title: 'MENU.ACADEMICO',
    children: [
      {
        id: 'Matricula',
        icon: 'circle',
        title: 'MENU.MATRICULAS',
        to: '/academico/matriculas/',
      },
      {
        id: 'Rematriculas',
        icon: 'circle',
        title: 'MENU.REMATRICULAS',
        to: '/academico/rematriculas/',
      },
      {
        id: 'Contrato',
        icon: 'circle',
        title: 'MENU.CONTRATOS',
        to: '/contratos/',
      },
      {
        id: 'AditivoContrato', //OK
        icon: 'circle',
        title: 'MENU.ADITIVOS_CONTRATO',
        to: '/contratos/aditivos',
      },
      {
        id: 'GerenciadorTurmas',
        icon: 'circle',
        title: 'MENU.GERENCIADOR_TURMAS',
        to: '/gerenciador-turmas',
      },
      {
        id: 'PainelProfessor',
        icon: 'circle',
        title: 'MENU.PAINEL_PROFESSOR',
        to: '/painel-professor',
      },
      // {
      //   id: 'PainelCoordenacao',
      //   icon: 'circle',
      //   title: 'MENU.PAINEL_COORDENACAO',
      //   to: '/painel-coordenacao',
      // },
      {
        id: 'Curso',
        icon: 'circle',
        title: 'MENU.CURSOS',
        to: '/academico/estrutura/cursos',
      },
      {
        id: 'GrupoTurma',
        icon: 'circle',
        title: 'MENU.GRUPOS_TURMA',
        to: '/academico/cej/grupos-turma',
      },
      {
        id: 'Disciplina',
        icon: 'circle',
        title: 'MENU.DISCIPLINAS',
        to: '/academico/cej/disciplinas',
      },
      {
        id: 'Turma',
        icon: 'circle',
        title: 'MENU.TURMAS',
        to: '/academico/cej/turmas',
      },
      {
        id: 'PeriodoLetivo',
        icon: 'circle',
        title: 'MENU.PERIODO_LETIVO',
        to: '/periodo-letivo',
      },
      {
        id: 'FechamentoPeriodoLetivo',
        icon: 'circle',
        title: 'MENU.FECHAMENTO_PERIODO_LETIVO',
        to: '/fechamento-periodo-letivo',
      },
      {
        id: 'FechamentoCursoTurma',
        icon: 'circle',
        title: 'MENU.FECHAMENTO_CURSOS_TURMAS',
        to: '/fechamento-cursos-turmas',
      },
      {
        id: 'DocentePeriodo',
        icon: 'circle',
        title: 'MENU.DOCENTES_PERIODO',
        to: '/academico/docentes-periodo',
      },
      {
        id: 'Boletim',
        icon: 'circle',
        title: 'MENU.BOLETINS',
        to: '/academico/boletins',
      },
      // {
      //   id: 'Aulas',
      //   icon: 'circle',
      //   title: 'MENU.AULAS',
      //   to: '/academico/diario-classe/aulas',
      // },
      // {
      //   id: 'Frequencias',
      //   icon: 'circle',
      //   title: 'MENU.FREQUENCIAS',
      //   to: '/academico/diario-classe/frequencias',
      // },
      // {
      //   id: 'Avaliacoes',
      //   icon: 'circle',
      //   title: 'MENU.AVALIACOES',
      //   to: '/academico/diario-classe/avaliacoes',
      // },
      // {
      //   id: 'Notas',
      //   icon: 'circle',
      //   title: 'MENU.NOTAS',
      //   to: '/academico/diario-classe/notas',
      // },
      {
        id: 'RelatorioDisciplina',
        icon: 'circle',
        title: 'MENU.RELATORIO_DISCIPLINA',
        to: '/relatorio-disciplinas',
      },
      {
        id: 'RelatorioTurmasAluno',
        icon: 'circle',
        title: 'MENU.RELATORIO_TURMAS_PARA_ALUNO',
        to: '/relatorio-turmas-para-aluno',
      },
      {
        id: 'RelatorioTurmas',
        icon: 'circle',
        title: 'MENU.RELATORIOS_TURMAS',
        to: '/relatorios-turmas',
      },
      {
        id: 'TipoAvaliacao',
        icon: 'circle',
        title: 'MENU.TIPO_DE_AVALIACAO',
        to: '/academico/cej/tipo-avaliacao',
      },
      {
        id: 'DocumentoPadrao',
        icon: 'circle',
        title: 'MENU.DOCUMENTO_PADRAO',
        to: '/academico/cej/documento-padrao',
      },
      {
        id: 'RelatorioDescontoParaContratos',
        icon: 'circle',
        title: 'MENU.RELATORIO_DESCONTOS_PARA_CONTRATOS',
        to: '/relatorio-descontos-para-contratos',
      },
      {
        id: 'RelatorioValoresParaContratos',
        icon: 'circle',
        title: 'MENU.RELATORIO_VALORES_PARA_CONTRATOS',
        to: '/relatorio-valores-para-contratos',
      },
      {
        id: 'RelatorioSituacaoDoContrato',
        icon: 'circle',
        title: 'MENU.RELATORIO_SITUACAO_CONTRATO',
        to: '/relatorios-situacao-contrato',
      },
      {
        id: 'RelatorioIrmaos',
        icon: 'circle',
        title: 'MENU.RELATORIO_IRMAOS',
        to: '/relatorio-irmaos',
      },
      {
        id: 'RelatorioBaseadoHistoricoEscolar',
        icon: 'circle',
        title: 'MENU.RELATORIOS_HISTORICO_ESCOLAR',
        to: '/relatorios-historico-escolar',
      },
      {
        id: 'RelatorioTotalizador',
        icon: 'circle',
        title: 'MENU.RELATORIO_TOTALIZADORES',
        to: '/relatorio-totalizadores',
      },
      {
        id: 'RelatorioFichaSocioEconomico',
        icon: 'circle',
        title: 'MENU.FICHA_SOCIOECONOMICA',
        to: '/relatorio-ficha-socioeconomica',
      },
      {
        id: 'Protocolo',
        icon: 'circle',
        title: 'MENU.PROTOCOLOS',
        to: '/protocolos',
      },
    ],
  },
  {
    id: 'CurriculoEscolar',
    icon: 'file-text',
    title: 'MENU.CURRICULO_ESCOLAR',
    children: [
      {
        id: 'InstituicaoEnsino',
        icon: 'circle',
        title: 'MENU.INSTITUICOES_ENSINO',
        to: '/instituicao-ensino',
      },
      {
        id: 'TurmaCurriculo',
        icon: 'circle',
        title: 'MENU.TURMAS',
        to: '/instituicao-ensino/turmas',
      },
      {
        id: 'DisciplinasCurriculoEscolar',
        icon: 'circle',
        title: 'MENU.DISCIPLINAS',
        to: '/instituicao-ensino/disciplinas',
      },
      {
        id: 'HistoricoEscolar',
        icon: 'circle',
        title: 'MENU.HISTORICO_ESCOLAR',
        to: '/instituicao-ensino/historico-escolar',
      },
    ],
  },
  {
    id: 'Financeiro',
    icon: 'dollar-sign',
    title: 'MENU.FINANCEIRO',
    children: [
      {
        id: 'Banco',
        icon: 'circle',
        title: 'MENU.BANCOS',
        to: '/financeiro/estrutura/bancos',
      },
      {
        id: 'Conta',
        icon: 'circle',
        title: 'MENU.CONTAS',
        to: '/financeiro/estrutura/contas',
      },
      {
        id: 'FormaPagamento',
        icon: 'circle',
        title: 'MENU.FORMAS_PAGAMENTO',
        to: '/financeiro/estrutura/formas-pagamento',
      },
      {
        id: 'Preco',
        icon: 'circle',
        title: 'MENU.PRECOS',
        to: '/financeiro/estrutura/precos',
      },
      {
        id: 'Desconto',
        icon: 'circle',
        title: 'MENU.DESCONTOS',
        to: '/financeiro/estrutura/descontos',
      },
      // {
      //   id: 'Impostos',
      //   icon: 'circle',
      //   title: 'MENU.IMPOSTOS',
      //   to: '/financeiro/estrutura/impostos',
      // },
      {
        id: 'ContasAPagar',
        icon: 'circle',
        title: 'MENU.LANCAMENTO_CONTAS_PAGAR',
        to: '/financeiro/contas-pagar',
      },
      {
        id: 'ContasAReceber',
        icon: 'circle',
        title: 'MENU.LANCAMENTO_CONTAS_RECEBER',
        to: '/financeiro/contas-a-receber',
      },
      {
        id: 'HistoricoLancamento',
        icon: 'circle',
        title: 'MENU.HISTORICO_LANCAMENTOS',
        to: '/financeiro/lancamentos/historico',
      },
      {
        id: 'IntegracaoFinanceiroContabil',
        icon: 'circle',
        title: 'MENU.INTEGRACAO_FINANCEIRA_CONTABIL',
        to: '/financeiro/lancamentos/integracao-contabil',
      },
      {
        id: 'PeriodoFinanceiro',
        icon: 'circle',
        title: 'MENU.PERIODO_FINANCEIRO',
        to: '/financeiro/caixa/periodo-financeiro',
      },
      {
        id: 'FluxoCaixa',
        icon: 'circle',
        title: 'MENU.FLUXO_CAIXA',
        to: '/financeiro/caixa/fluxo',
      },
      {
        id: 'Cobranca',
        icon: 'circle',
        title: 'MENU.COBRANCA',
        to: '/financeiro/cobranca',
      },
      {
        id: 'Fornecedor',
        icon: 'circle',
        title: 'MENU.FORNECEDORES',
        to: '/financeiro/estrutura/fornecedores',
      },
      {
        id: 'GerenciarBoletos',
        icon: 'circle',
        title: 'MENU.GERENCIAR_BOLETOS',
        to: '/financeiro/estrutura/gerenciar-boletos',
      },
      {
        id: 'ConsultaBoletos',
        icon: 'circle',
        title: 'MENU.CONSULTA_BOLETOS',
        to: '/financeiro/consulta-boletos',
      },
      {
        id: 'RelCPAnaliseRetroativaContaPagar',
        icon: 'circle',
        title: 'MENU.IMPRIMIR_RELATORIO_ANALISE_RETROATIVA_CONTAS_PAGAR',
        to: '/financeiro/relatorio/contas-a-pagar/analise-retroativa',
      },
      {
        id: 'RelCPAnaliseRetroativaContaReceber',
        icon: 'circle',
        title: 'MENU.IMPRIMIR_RELATORIO_ANALISE_RETROATIVA_CONTAS_RECEBER',
        to: '/financeiro/relatorio/contas-a-receber/analise-retroativa',
      },
      {
        id: 'RelatorioDeclaracaoImpostoRenda',
        icon: 'circle',
        title: 'MENU.RELATORIO_DECLARACAO_IMPOSTO_RENDA',
        to: '/financeiro/relatorio/faturamento/declaracao-imposto-renda',
      },
      {
        id: 'RelatorioFaturamento',
        icon: 'circle',
        title: 'MENU.RELATORIO_FATURAMENTO',
        to: '/financeiro/relatorio/faturamento',
      },
    ],
  },
  {
    id: 'Contábil',
    icon: 'box',
    title: 'MENU.CONTABIL',
    children: [
      {
        id: 'Faturamento',
        icon: 'circle',
        title: 'Faturamentos',
        to: '/contabil/faturamentos',
      },
      {
        id: 'PlanoContas',
        icon: 'circle',
        title: 'MENU.PLANO_CONTAS',
        to: '/contabil/plano-contas',
      },
      {
        id: 'PeriodoContabil',
        icon: 'circle',
        title: 'MENU.PERIODOS_CONTABEIS',
        to: '/contabil/periodos',
      },
      {
        id: 'LancamentoContabil',
        icon: 'circle',
        title: 'MENU.LANCAMENTOS_CONTABEIS',
        to: '/contabil/lancamentos',
      },
      // {
      //   id: 'FechamentoContabil',
      //   icon: 'circle',
      //   title: 'MENU.FECHAMENTO_CONTABIL',
      //   to: '/contabil/fechamento',
      // },
      {
        id: 'RelatorioLancamentoPorPeriodo',
        icon: 'circle',
        title: 'MENU.RELATORIO_LANCAMENTOS_POR_PERIODO',
        to: '/contabil/lancamento-por-periodo',
      },
      {
        id: 'RelatorioBalancete',
        icon: 'circle',
        title: 'MENU.RELATORIO_BALANCETE',
        to: '/contabil/balancete',
      },
      {
        id: 'RelatorioDiario',
        icon: 'circle',
        title: 'MENU.RELATORIO_DIARIO',
        to: '/contabil/diario',
      },
      {
        id: 'RelatorioRazao',
        icon: 'circle',
        title: 'MENU.RELATORIO_RAZAO',
        to: '/contabil/razao',
      },
    ],
  },
  {
    id: 'Suprimentos',
    icon: 'inbox',
    title: 'MENU.SUPRIMENTOS',
    children: [
      {
        id: 'LancamentoNF',
        icon: 'circle',
        title: 'MENU.LANCAMENTOS_NF',
        to: '/suprimentos/lancamentos-nf',
      },
      {
        id: 'Estoque',
        icon: 'circle',
        title: 'MENU.ESTOQUE',
        to: '/suprimentos/estoques',
      },
      {
        id: 'RelatorioEstoques',
        icon: 'circle',
        title: 'MENU.RELATORIO_ESTOQUE',
        to: '/suprimentos/relatorio-estoque',
      },
      {
        id: 'Depositos',
        icon: 'circle',
        title: 'MENU.DEPOSITOS',
        to: '/suprimentos/depositos',
      },
      {
        id: 'Produto',
        icon: 'circle',
        title: 'MENU.PRODUTOS',
        to: '/suprimentos/produtos',
      },
    ],
  },
  {
    id: 'Admin',
    icon: 'users',
    title: 'MENU.RECURSOS_HUMANOS',
    children: [
      {
        id: 'Pessoa',
        icon: 'circle',
        title: 'MENU.PESSOAS',
        to: '/pessoas',
      },
      {
        id: 'Funcionario',
        icon: 'circle',
        title: 'MENU.FUNCIONARIOS',
        to: '/funcionarios',
      },
      {
        id: 'Funcionario',
        icon: 'circle',
        title: 'MENU.RELATORIO_FUNCIONARIOS',
        to: '/relatorio-funcionarios',
      },
      {
        id: 'Usuario',
        icon: 'circle',
        title: 'MENU.USUARIOS',
        to: '/usuarios',
      },
      {
        id: 'Perfil',
        icon: 'circle',
        title: 'MENU.PERFIS',
        to: '/perfis',
      },
    ],
  },
];

export default listaMenus;
